import { threeDStudioStore } from '../index'

/**
 * Stores the live viewer instance so the viewer sidebar (rendered outside
 * ViewerContext) can invoke imperative actions like setMeshVisibility,
 * removeMesh and setExplodedViewEnabled. Kept in the dedicated `staticViewer`
 * slice so per-model resets that rebuild the `viewer` slice never clobber it.
 * @param {object|null} instance - the cgt-viewer instance, or null when disposed
 */
export const setViewerInstance = (instance) => {
  threeDStudioStore.setState((state) => ({
    staticViewer: { ...state.staticViewer, instance },
  }))
}
